module.exports = __webpack_public_path__ + "graphics/player-next.ckh.df6ce0c047fcbbc011d372df72197f23.svg";